import { LessonPlanDocumentType, LessonPlanType } from "../../../types/LessonPlan";
import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { get } from "../../../utils/axios-config";
import { LESSON_PLANS, LESSON_PLANS_DOCUMENTS } from "../../../utils/constants";


export const getLessonPlans = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdSubjectPlan ? { IdSubjectPlan: data.IdSubjectPlan } : {}),
        ...(data?.IdClass ? { IdClass: data.IdClass } : {}),
        ...(data?.IdCourse ? { IdCourse : data.IdCourse } : {}),
        ...(data?.IdTeacher ? { IdTeacher: data.IdTeacher } : {}),
        ...(data?.IdSubject ? { IdSubject: data.IdSubject } : {}),
    });
    const url = `${LESSON_PLANS}?${queryParams.toString()}`;
    return await get<PagedResultsType<LessonPlanType>>(url)
};

export const getLessonPlansDocuments = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdSubjectPlan ? { IdSubjectPlan: data.IdSubjectPlan } : {}),
        ...(data?.IdLessonPlan ? { IdLessonPlan: data.IdLessonPlan } : {}),
        ...(data?.IdClass ? { IdClass: data.IdClass } : {}),
        ...(data?.IdCourse ? { IdCourse: data.IdCourse } : {}),
        ...(data?.IdTeacher ? { IdTeacher: data.IdTeacher } : {}),
        ...(data?.IdSubject ? { IdSubject: data.IdSubject } : {}),
    });
    const url = `${LESSON_PLANS_DOCUMENTS}?${queryParams.toString()}`;
    return await get<PagedResultsType<LessonPlanDocumentType>>(url)
};




